<template>
    <Wrapper>
        <div class="row">
            <div class="col-lg-7 col-xl-8 py-1">
                <div class="row">
                    <div class="col-12 pb-4">
                        <div class="card card-body mb-1 shadow-sm">
                            <h3 class="mb-4">Live</h3>
                            <LiveChart class="live-chart-wrapper" :height="330" 
                                :chart-data="liveChartData"
                                @init="init" 
                                @load-more="loadMore" 
                                @counter="counterChanged"
                                :live="isLive" 
                                :speed="400" 
                                :max-intervals="maxIntervals" />
                        </div>
                    </div>
                    <div class="col-12 pb-4">
                        <div class="card card-body mb-1 shadow-sm">
                            <h3 class="mb-4">Bar</h3>
                            <BarChart></BarChart>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card card-body mb-1 shadow-sm">
                            <h3 class="mb-4">Line</h3>
                            <LineChart :colors="['violet','lime','purple']"></LineChart>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-xl-4 py-1">
                <div class="row">
                    <div class="col-12 pb-4">
                        <div class="card mb-1 shadow-sm">
                            <div class="card-body">
                                <h3 class="mb-4">Donut</h3>
                                <div class="row">
                                    <div class="col-md-4 col-lg-12 pb-5">
                                        <DonutChart ref="donutChart1" class="mt-3 mx-auto"></DonutChart>
                                    </div>
                                    <div class="col-md-4 col-lg-12 pb-5">
                                        <DonutChart ref="donutChart2" :data="dataDonut2" class="mt-3 mx-auto"></DonutChart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 pb-4">
                        <div class="card mt-1 shadow-sm">
                            <div class="card-body">
                                <h3 class="mb-4">Pie</h3>
                                <div class="row">
                                    <div class="col-md-4 col-lg-12 pb-5">
                                        <DonutChart ref="donutChart3" :data="dataDonut3" :options="{cutoutPercentage:'0.1',legend:{display:false}}" class="mt-3 mx-auto"></DonutChart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Wrapper>
</template>
<script>
import { Wrapper, LiveChart, BarChart, LineChart, DonutChart } from '../components';

export default {
    components: {
        Wrapper,
        LiveChart,
        BarChart,
        LineChart,
        DonutChart
    },
    data() {
        return {
            dataDonut2: {
                "labels": ["Hip", "Hop", "Hat"],
                "datasets": [{
                    "borderWidth": 0,
                    "data": [10, 20, 60]
                }]
            },
            dataDonut3: {
                "labels": ["Run", "Pass", "Catch"],
                "datasets": [{
                    "backgroundColor": ["#e0e0e0","#cfcfcf","#dfdfdf"],
                    "borderWidth": 0,
                    "data": [10, 70, 5]
                }]
            },
            liveData: {
                labels: [],
                datasets: []
            },
            timeFrame: 8,
            tFrame: [],
            times: [],
            incr: 0,
            maxIntervals: 50,
            isLive: true
        }
    },
    computed: {
        liveChartData() {
            return this.liveData;
        }
    },
    methods: {
        init (event) {
            
            this.times = this.genTimes(30,24);
            this.tFrame = this.times.slice(0, this.timeFrame);
            this.liveChartData = event;
            
            // get first batch of live data 
            this.liveChartData.labels = this.tFrame;
            this.liveChartData.datasets = [
                {
                  label: 'Dags',
                  data: this.getRandomArr(this.timeFrame)
                }, {
                  label: 'Hogs',
                  data: this.getRandomArr(this.timeFrame)
                }, {
                  label: 'Pops',
                  data: this.getRandomArr(this.timeFrame)
                }, {
                  label: 'Wips',
                  data: this.getRandomArr(this.timeFrame)
                }
            ]
        },
        loadMore () {
            
            // update time frame
            this.times.slice(0,this.times.length-1).join(",");
            this.times.push(this.times.shift());
            
            this.tFrame = this.times.slice(1, 1+this.timeFrame);
            this.liveData.labels = this.tFrame;
            
            // get more live data  
            for (var idx in this.liveData.datasets) {
                var tmp = this.liveData.datasets[idx];
                tmp.data.shift();
                // append new data to last point
                tmp.data.splice(this.tFrame.length-1,1,this.getRandomInt());
                this.liveData.datasets.splice(idx,1,tmp);
            }
              
        },
        counterChanged(val) {
            this.incr = val;
        },
        toggleLive() {
            this.isLive = !this.isLive;
        },
        getRandomArr (len) {
            var arr = [];
            for (var i=0;i<len;i++) {
                arr.push(this.getRandomInt());
            }
            return arr;
        },
        getRandomInt () {
            var rand = Math.floor(Math.random() * (18 - 2 + 1)) + 1;
            return rand;
        },
        genTimes (interval,number) {
            var times = []; // time array
            var tt = 0; // start time
            var ap = [' AM',' PM']; // AM-PM
            
            for (var i=0;tt<number*60; i++) {
              var hh = Math.floor(tt/60);
              var mm = (tt%60);
              times[i] = ("" + ((hh==12||hh==0)?12:hh%12)).slice(-2) + ':' + ("0" + mm).slice(-2);
              tt = tt + interval;
            }
            return times;
        },
        getDateTime() {
            return new Date().toLocaleTimeString("en-US",{  
                weekday: "long", year: "numeric", month: "short",  
                day: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit"
            });
        }
    }
};
</script>
